import { pdfjs } from 'react-pdf';

/**
 * Shared pdf.js setup for every component rendering a PDF.
 *
 * Two things are configured here rather than in each component.
 *
 * The worker is served by the application itself. It used to be fetched from a public
 * JavaScript CDN at runtime, which made rendering a PDF depend on a third party being
 * reachable and trustworthy — untenable for a deployment without outbound internet
 * access, and an unnecessary supply-chain dependency. `bin/copy-pdf-worker.js` copies
 * the file shipped with pdfjs-dist into the backend statics at build time, so the
 * bundled library and its worker are always the same version.
 *
 * `isEvalSupported: false` mitigates CVE-2024-4367. pdfjs-dist 2.6.347 compiles glyph
 * drawing commands taken from the font program into a JavaScript function:
 *
 *     if (this.isEvalSupported && IsEvalSupportedCached.value) {
 *       ...
 *       return this.compiledGlyphs[character] = new Function("c", "size", js);
 *     }
 *
 * A crafted PDF can therefore execute arbitrary script in the page that renders it.
 * Setting the flag to false takes that branch out and falls back to the interpreted
 * path. This is a mitigation, not the fix: upgrading react-pdf past pdfjs-dist 4.2.67
 * remains necessary, and is a breaking API change tracked separately.
 */
pdfjs.GlobalWorkerOptions.workerSrc = '/static/js/pdf.worker.js';

/**
 * Options passed to every `<Document>`.
 *
 * Declared once at module level on purpose: react-pdf compares this prop by reference
 * and reloads the document whenever it changes, so an object literal written inline in
 * a component would rebuild the document on every render.
 */
export const PDF_DOCUMENT_OPTIONS = {
  isEvalSupported: false,
};
